import { render, staticRenderFns } from "./cust-contactInfo.vue?vue&type=template&id=ee70d2d8&scoped=true"
import script from "./cust-contactInfo.vue?vue&type=script&lang=js"
export * from "./cust-contactInfo.vue?vue&type=script&lang=js"
import style0 from "./cust-contactInfo.vue?vue&type=style&index=0&id=ee70d2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee70d2d8",
  null
  
)

export default component.exports